<template>
    <v-container
        fill-height
        class="align-start"
    >
        <div
            class="row no-gutters"
            width="100%"
        >
            <v-col>
                <v-toolbar
                    class="elevation-0 mt-n3 row-full"
                    height="relative"
                >
                    <div class="container d-flex pb-3 pt-2 align-center">
                        <v-toolbar-title
                            color="primary"
                            class="headline font-weight-bold text-capitalize"
                        >
                            Health Insurance Packages in Nigeria
                        </v-toolbar-title>
                    </div>
                    <template v-slot:extension>
                        <div
                            class="container pb-7 d-lg-flex"
                            :class="{'d-flex': !showComparison}"
                        >
                            <div
                                v-if="!showComparison"
                                style="max-width:190px;"
                                class="selection--teal"
                            >
                                <v-select
                                    flat
                                    :items="product.prices"
                                    hide-details
                                    solo
                                    dense
                                    menu-props="offset-y"
                                    width="160px"
                                    background-color="#f8f8fd"
                                    color="grey darken-4"
                                    item-color="primary"
                                    prefix="Price"
                                    class="selection--teal"
                                    clearable
                                    @change="getRange"
                                />
                            </div>

                            <v-row
                                v-else
                                align="center"
                            >
                                <v-col cols="6">
                                    <div
                                        style="max-width:190px;"
                                        class="selection--teal"
                                    >
                                        <v-select
                                            v-model="firstCompany"
                                            flat
                                            hide-details
                                            :items="providers"
                                            solo
                                            dense
                                            :menu-props="{'offset-y': true, 'max-width': 500}"
                                            width="160px"
                                            background-color="#f8f8fd"
                                            color="grey darken-4"
                                            item-color="primary"
                                            item-text="name"
                                            item-value="abbreviation"
                                            return-object
                                            class="selection--teal browse-text"
                                            @change="secondCompany = null"
                                        />
                                    </div>
                                </v-col>
                                <v-col
                                    v-if="firstCompany"
                                    cols="6"
                                >
                                    <div
                                        style="max-width:190px;"
                                        class="selection--teal"
                                    >
                                        <v-select
                                            v-model="secondCompany"
                                            flat
                                            hide-details
                                            :items="providers.filter(key => key.name !== firstCompany.name)"
                                            solo
                                            dense
                                            :menu-props="{'offset-y': true, 'max-width': 500}"
                                            width="160px"
                                            background-color="#f8f8fd"
                                            color="grey darken-4"
                                            item-color="primary"
                                            item-text="name"
                                            item-value="abbreviation"
                                            return-object
                                            class="selection--teal browse-text"
                                        />
                                    </div>
                                </v-col>
                            </v-row>

                            <v-spacer v-if="!$vuetify.breakpoint.smAndDown && !showComparison" />

                            <v-btn
                                v-if="!showComparison"
                                depressed
                                class="align-self-center noBtnCase ml-1 primary--text"
                                color="#f8f8fd"
                                @click="showComparison = true"
                            >
                                Compare
                                <v-icon>mdi-filter-outline</v-icon>
                            </v-btn>
                            <div
                                v-else
                                class="text-center"
                            >
                                <v-btn
                                    icon
                                    color="primary"
                                    @click="showComparison = false"
                                >
                                    Close <v-icon>mdi-close</v-icon>
                                </v-btn>
                            </div>
                        </div>
                    </template>
                </v-toolbar>

                <loading-overlay :loading="loading" />

                <template v-if="!showComparison">
                    <v-row
                        id="container"
                        class="fill-height overflow-auto"
                    >
                        <v-col
                            v-for="item in providers"
                            :key="item.name"
                            lg="4"
                            col="6"
                            class="col-12 py-2"
                        >
                            <packageItem
                                :item="item"
                                @view-item="viewItem"
                            />
                        </v-col>
                    </v-row>
                </template>

                <template v-else>
                    <v-simple-table
                        v-if="firstCompany && secondCompany"
                        fixed-header
                    >
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-left title">
                                        Services
                                    </th>
                                    <th class="text-center title">
                                        {{ firstCompany.name }}
                                    </th>
                                    <th class="text-center title">
                                        {{ secondCompany.name }}
                                    </th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr>
                                    <td class="pa-3 pl-4">
                                        Specialist Consultation
                                    </td>
                                    <td class="pa-3 text-center">
                                        {{ firstCompanyServices.includes('consult') ? 'Yes' : 'No' }}
                                    </td>
                                    <td class="pa-3 text-center">
                                        {{ secondCompanyServices.includes('consult') ? 'Yes' : 'No' }}
                                    </td>
                                </tr>
                                <tr>
                                    <td class="pa-3 pl-4">
                                        Dental Care
                                    </td>
                                    <td class="pa-3 text-center">
                                        {{ firstCompanyServices.includes('dent') ? 'Yes' : 'No' }}
                                    </td>
                                    <td class="pa-3 text-center">
                                        {{ secondCompanyServices.includes('dent') ? 'Yes' : 'No' }}
                                    </td>
                                </tr>
                                <tr>
                                    <td class="pa-3 pl-4">
                                        Physiotherapy
                                    </td>
                                    <td class="pa-3 text-center">
                                        {{ firstCompanyServices.includes('physio') ? 'Yes' : 'No' }}
                                    </td>
                                    <td class="pa-3 text-center">
                                        {{ secondCompanyServices.includes('physio') ? 'Yes' : 'No' }}
                                    </td>
                                </tr>
                                <tr>
                                    <td class="pa-3 pl-4">
                                        Lab Investigations
                                    </td>
                                    <td class="pa-3 text-center">
                                        {{ firstCompanyServices.includes('lab') || firstCompanyServices.includes('investig') ? 'Yes' : 'No' }}
                                    </td>
                                    <td class="pa-3 text-center">
                                        {{ secondCompanyServices.includes('consult') || secondCompanyServices.includes('investig') ? 'Yes' : 'No' }}
                                    </td>
                                </tr>
                                <tr>
                                    <td class="pa-3 pl-4">
                                        Prescribed Medicine & Drugs
                                    </td>
                                    <td class="pa-3 text-center">
                                        {{ firstCompanyServices.includes('medici') || firstCompanyServices.includes('medica') || firstCompanyServices.includes('drugs') ? 'Yes' : 'No' }}
                                    </td>
                                    <td class="pa-3 text-center">
                                        {{ secondCompanyServices.includes('medici') || secondCompanyServices.includes('medica') || secondCompanyServices.includes('drugs') ? 'Yes' : 'No' }}
                                    </td>
                                </tr>
                                <tr>
                                    <td class="pa-3 pl-4">
                                        Plain & Contrast X-Rays
                                    </td>
                                    <td class="pa-3 text-center">
                                        {{ firstCompanyServices.includes('ray') ? 'Yes' : 'No' }}
                                    </td>
                                    <td class="pa-3 text-center">
                                        {{ secondCompanyServices.includes('ray') ? 'Yes' : 'No' }}
                                    </td>
                                </tr>
                                <tr>
                                    <td class="pa-3 pl-4">
                                        Family Planning Services
                                    </td>
                                    <td class="pa-3 text-center">
                                        {{ firstCompanyServices.includes('family') ? 'Yes' : 'No' }}
                                    </td>
                                    <td class="pa-3 text-center">
                                        {{ secondCompanyServices.includes('family') ? 'Yes' : 'No' }}
                                    </td>
                                </tr>
                                <tr>
                                    <td class="pa-3 pl-4">
                                        Routine Medical Check
                                    </td>
                                    <td class="pa-3 text-center">
                                        {{ firstCompanyServices.includes('routine') ? 'Yes' : 'No' }}
                                    </td>
                                    <td class="pa-3 text-center">
                                        {{ secondCompanyServices.includes('routine') ? 'Yes' : 'No' }}
                                    </td>
                                </tr>
                                <tr>
                                    <td class="pa-3 pl-4">
                                        Minor & Major Surgeries
                                    </td>
                                    <td class="pa-3 text-center">
                                        {{ firstCompanyServices.includes('surge') ? 'Yes' : 'No' }}
                                    </td>
                                    <td class="pa-3 text-center">
                                        {{ secondCompanyServices.includes('surge') ? 'Yes' : 'No' }}
                                    </td>
                                </tr>
                                <tr>
                                    <td class="pa-3 pl-4">
                                        Ward admission & Feeding
                                    </td>
                                    <td class="pa-3 text-center">
                                        {{ firstCompanyServices.includes('admis') || firstCompanyServices.includes('fee') ? 'Yes' : 'No' }}
                                    </td>
                                    <td class="pa-3 text-center">
                                        {{ secondCompanyServices.includes('admis') || secondCompanyServices.includes('fee') ? 'Yes' : 'No' }}
                                    </td>
                                </tr>
                                <tr>
                                    <td class="pa-3 pl-4">
                                        Antenatal Care & Delivery
                                    </td>
                                    <td class="pa-3 text-center">
                                        {{ firstCompanyServices.includes('antenatal') ? 'Yes' : 'No' }}
                                    </td>
                                    <td class="pa-3 text-center">
                                        {{ secondCompanyServices.includes('antenatal') ? 'Yes' : 'No' }}
                                    </td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>


                    <div
                        v-else
                        class="text-center mt-5"
                    >
                        <p
                            v-if="!firstCompany"
                            class="title"
                        >
                            Select two companies to compare
                        </p>
                        <p v-else>
                            Select another company to compare with {{ firstCompany.name }}
                        </p>
                    </div>
                </template>
            </v-col>

            <viewPackage
                :item="item"
                :visible="showView"
                @selected="buy"
                @close="showView = false"
            />
        </div>
    </v-container>
</template>

<script>
    import packageItem from './components/package.vue';
    import viewPackage from './components/view.vue';

    export default {
        components: { packageItem, viewPackage },
        data: () => ({
            name: 'Oloyede Oluwaseyi',
            product: {
                data: [],
            },
            filters: {
                brand: '',
                year: '',
            },
            type: '',
            starRating: 0,
            showFilters: false,
            loading: false,
            pagination: {
                ordersPerPage: 5,
                page: 1,
                pageCount: 0,
            },
            item: {},
            showView: false,
            showComparison: false,
            price: {
                min: 0,
                max: 10000000,
            },
            providers: [],
            firstCompany: null,
            secondCompany: null,
        }),
        computed: {
            firstCompanyServices() {
                return this.firstCompany.benefits.join().toLowerCase();
            },
            secondCompanyServices() {
                return this.secondCompany.benefits.join().toLowerCase();
            },
        },
        mounted() {
            this.loadHealthInsuranceProviders();
        },
        methods: {
            viewItem(item) {
                this.item = item;
                this.showView = true;
            },
            buy() {
                this.loading = true;
                setTimeout(() => {
                    this.loading = false;
                    this.$swal({
                        type: 'success',
                        text: 'Your request is being processed!',
                    });
                    this.$router.push('/healthcare');
                }, 3000);
            },
            getRange(val) {
                if (val.includes('-')) {
                    const price = val.replace(/\$/g, '').replace(/\$/g, '').split(' - ');
                    this.price = {
                        min: Number(price[0]),
                        max: Number(price[1]),
                    };
                } else {
                    const dollarIndex = val.indexOf('$');
                    const price = Number(val.slice(dollarIndex + 1));

                    this.price = {
                        min: val.includes('Below') ? 0 : price,
                        max: val.includes('Above') ? price : 10000000,
                    };
                }
            },

            async loadHealthInsuranceProviders() {
                try {
                    const { data } = await Vue.backendApi()
                        .healthInsuranceProviders()
                        .getAll();

                    this.providers = data;
                } catch (err) {
                    this.$swal({
                        type: 'error',
                        title: 'Error',
                        text: err,
                    });
                    throw err;
                }
            },
        },
    };
</script>

<style scoped>
.theme--light.v-pagination .v-pagination__item {
    background: none !important;
    color: #4147d6;
}

@media screen and (max-width: 768px) {
    .v-toolbar__extension {
        height: 100px !important;
    }
}
</style>
